var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image text-center bg-transparent ",style:(_vm.urlProps)},[_c('h1',{staticClass:"text-white font-display text-5xl pt-44 s:text-4xl"},[(_vm.text)?_c('div',[_vm._v(" "+_vm._s(_vm.text)+" ")]):_c('div')])])}
var staticRenderFns = []

export { render, staticRenderFns }